import React, { createContext, useContext, useState, useCallback } from 'react';

const FileViewerContext = createContext();

export const useFileViewer = () => {
  const context = useContext(FileViewerContext);
  if (!context) {
    throw new Error('useFileViewer must be used within a FileViewerProvider');
  }
  return context;
};

export const FileViewerProvider = ({ children }) => {
  const [viewerState, setViewerState] = useState({
    isOpen: false,
    fileUrl: null,
    fileType: 'auto', // 'image', 'pdf', or 'auto'
    fileName: 'Document'
  });

  const openViewer = useCallback((url, name = 'Document', type = 'auto') => {
    let detectedType = type;
    
    // Auto-detect type if not specified
    if (type === 'auto') {
      const lowerName = name.toLowerCase();
      if (lowerName.endsWith('.pdf')) {
        detectedType = 'pdf';
      } else if (url && url.startsWith('data:application/pdf')) {
        detectedType = 'pdf';
      } else if (lowerName.match(/\.(jpg|jpeg|png|gif|webp|svg|bmp|tiff)$/)) {
        detectedType = 'image';
      } else if (url && url.startsWith('data:image/')) {
        detectedType = 'image';
      } else {
        // Default fallback
        detectedType = 'image';
      }
    }

    // ✅ إذا كان PDF، افتحه في tab جديد بدل الـ viewer
    if (detectedType === 'pdf') {
      console.log('Opening PDF in new tab:', url);
      window.open(url, '_blank', 'noopener,noreferrer');
      return; // ✅ متفتحش الـ modal viewer
    }

    // ✅ للصور والملفات التانية، استخدم الـ viewer العادي
    setViewerState({
      isOpen: true,
      fileUrl: url,
      fileType: detectedType,
      fileName: name
    });
  }, []);

  const closeViewer = useCallback(() => {
    setViewerState(prev => ({ ...prev, isOpen: false }));
  }, []);

  return (
    <FileViewerContext.Provider value={{ ...viewerState, openViewer, closeViewer }}>
      {children}
    </FileViewerContext.Provider>
  );
};
